import { Product } from '../types';

// ============================================
// HOLDERS & CONNECTORS
// ============================================

// UNIVERSAL HOLDERS
export const holderProducts: Product[] = [
  {
    id: "holder-1",
    name: "090 Series Sealed Holder",
    slug: "090-series-sealed-holder",
    category: "Holders",
    subcategory: "090 Series",
    description: "Sealed connector holder for 090 series terminals. Water resistant.",
    specifications: {
      "Series": "090",
      "Type": "Sealed",
      "Feature": "Water resistant",
    },
    tags: ["holder", "090", "sealed"],
    applications: ["Automotive", "Connectors"],
  },
  {
    id: "holder-2",
    name: "090 Series Non-Sealed Holder",
    slug: "090-series-non-sealed-holder",
    category: "Holders",
    subcategory: "090 Series",
    description: "Non-sealed connector holder for 090 series terminals.",
    specifications: {
      "Series": "090",
      "Type": "Non-Sealed",
    },
    tags: ["holder", "090", "non-sealed"],
    applications: ["Automotive", "Connectors"],
  },
  {
    id: "holder-3",
    name: "090 Water Proof Series Holder",
    slug: "090-waterproof-holder",
    category: "Holders",
    subcategory: "090 Series",
    description: "Waterproof connector holder for 090 series. IP67 rated.",
    featured: true,
    specifications: {
      "Series": "090",
      "Type": "Waterproof",
      "Rating": "IP67",
    },
    tags: ["holder", "090", "waterproof"],
    applications: ["Automotive", "Harsh Environments"],
  },
  {
    id: "holder-4",
    name: "090 PBT Series Holder",
    slug: "090-pbt-holder",
    category: "Holders",
    subcategory: "090 Series",
    description: "High-temperature PBT plastic holder for 090 series.",
    specifications: {
      "Series": "090",
      "Material": "PBT",
      "Feature": "High temperature resistant",
    },
    tags: ["holder", "090", "pbt"],
    applications: ["Automotive", "High Temperature"],
  },
  {
    id: "holder-5",
    name: "0110 Series Holder",
    slug: "0110-series-holder",
    category: "Holders",
    subcategory: "0110 Series",
    description: "Connector holder for 0110 series (2.8mm) terminals.",
    specifications: {
      "Series": "0110 (2.8mm)",
    },
    tags: ["holder", "0110"],
    applications: ["Automotive", "Connectors"],
  },
  {
    id: "holder-6",
    name: "0250 Series Holder",
    slug: "0250-series-holder",
    category: "Holders",
    subcategory: "0250 Series",
    description: "Connector holder for 0250 series (6.3mm) terminals.",
    featured: true,
    specifications: {
      "Series": "0250 (6.3mm)",
    },
    tags: ["holder", "0250"],
    applications: ["Automotive", "Connectors"],
  },
  {
    id: "holder-7",
    name: "Special Holder",
    slug: "special-holder",
    category: "Holders",
    subcategory: "Special",
    description: "Specialized connector holders for unique applications.",
    specifications: {
      "Type": "Special/Custom",
    },
    tags: ["holder", "special", "custom"],
    applications: ["Custom Applications"],
  },
  {
    id: "holder-8",
    name: "Jointer Holder",
    slug: "jointer-holder",
    category: "Holders",
    subcategory: "Jointer",
    description: "Holder for jointer/inline connections.",
    specifications: {
      "Type": "Jointer/Inline",
    },
    tags: ["holder", "jointer"],
    applications: ["Automotive", "Wire Connections"],
  },
];

// CONNECTORS
export const connectorProducts: Product[] = [
  {
    id: "conn-1",
    name: "Flasher & Relay Base Connector",
    slug: "flasher-relay-connector",
    category: "Connectors",
    subcategory: "Relay Connectors",
    description: "Base connector for flasher and relay mounting.",
    featured: true,
    specifications: {
      "Applications": "Flasher, Relay mounting",
    },
    tags: ["connector", "flasher", "relay"],
    applications: ["Automotive", "Relay Mounting"],
  },
  {
    id: "conn-2",
    name: "Head Lamp Connector",
    slug: "headlamp-connector",
    category: "Connectors",
    subcategory: "Lamp Connectors",
    description: "H4/H7 headlamp connectors for bulb connection.",
    featured: true,
    specifications: {
      "Types": "H4, H7, H1",
      "Applications": "Headlamp bulb connection",
    },
    tags: ["connector", "headlamp", "bulb"],
    applications: ["Automotive", "Lighting"],
  },
  {
    id: "conn-3",
    name: "Sensor Connector",
    slug: "sensor-connector",
    category: "Connectors",
    subcategory: "Sensor Connectors",
    description: "Connectors for various automotive sensors.",
    specifications: {
      "Applications": "Temperature, Pressure, Speed sensors",
    },
    tags: ["connector", "sensor"],
    applications: ["Automotive", "Sensors"],
  },
  {
    id: "conn-4",
    name: "Super Sealed Connector",
    slug: "super-sealed-connector",
    category: "Connectors",
    subcategory: "Sealed Connectors",
    description: "High-grade sealed connectors for harsh environments.",
    featured: true,
    specifications: {
      "Type": "Sealed",
      "Feature": "Waterproof, Dustproof",
    },
    tags: ["connector", "sealed", "waterproof"],
    applications: ["Automotive", "Harsh Environments"],
  },
  {
    id: "conn-5",
    name: "Single Fuse Connector",
    slug: "single-fuse-connector",
    category: "Connectors",
    subcategory: "Fuse Connectors",
    description: "Inline single fuse holder connector.",
    specifications: {
      "Type": "Inline Fuse Holder",
      "Fuse Type": "Blade",
    },
    tags: ["connector", "fuse", "inline"],
    applications: ["Automotive", "Fuse Protection"],
  },
  {
    id: "conn-6",
    name: "Combination Connector",
    slug: "combination-connector",
    category: "Connectors",
    subcategory: "Multi-Purpose",
    description: "Multi-purpose combination connectors.",
    specifications: {
      "Type": "Combination/Multi-purpose",
    },
    tags: ["connector", "combination"],
    applications: ["Automotive", "Multi-Purpose"],
  },
  {
    id: "conn-7",
    name: "Round Connector",
    slug: "round-connector",
    category: "Connectors",
    subcategory: "Round Connectors",
    description: "Round DIN style connectors for automotive applications.",
    specifications: {
      "Type": "Round/DIN",
    },
    tags: ["connector", "round", "din"],
    applications: ["Automotive"],
  },
  {
    id: "conn-8",
    name: "ECM Connector",
    slug: "ecm-connector",
    category: "Connectors",
    subcategory: "ECM Connectors",
    description: "Engine Control Module (ECM) connectors for fuel injection systems.",
    featured: true,
    specifications: {
      "Applications": "ECM, ECU connections",
      "Pins": "Multiple configurations",
    },
    tags: ["connector", "ecm", "engine"],
    applications: ["Automotive", "Engine Management"],
  },
  {
    id: "conn-9",
    name: "JCB Connector",
    slug: "jcb-connector",
    category: "Connectors",
    subcategory: "JCB Connectors",
    description: "Heavy-duty connectors for JCB and earth moving equipment. Available in 9, 14, 16, 18, 21, 23, 29, 31, 32 pole configurations.",
    featured: true,
    specifications: {
      "Applications": "JCB, Earth Moving Equipment",
      "Poles": "9, 14, 16, 18, 21, 23, 29, 31, 32",
      "Wire": "4mm & 5mm Deluxe Wire",
    },
    tags: ["connector", "jcb", "heavy-duty"],
    applications: ["Heavy Machinery", "JCB Equipment"],
  },
  {
    id: "conn-10",
    name: "JPT Sensor Connectors",
    slug: "jpt-sensor-connectors",
    category: "Connectors",
    subcategory: "JPT Connectors",
    description: "JPT series connectors for automotive sensors. Available in 2, 3, 4, 5, and 6 pole configurations.",
    specifications: {
      "Type": "JPT",
      "Poles": "2, 3, 4, 5, 6",
      "Applications": "Sensors, Injectors",
    },
    tags: ["connector", "jpt", "sensor"],
    applications: ["Automotive", "Sensors", "Injectors"],
  },
];

// JOINTER HOLDERS (from Catalog III)
export const jointerHolderProducts: Product[] = [
  {
    id: "jh-1",
    name: "Joint Holder with Special Wire",
    slug: "joint-holder-special",
    category: "Holders",
    subcategory: "Jointer Holders",
    description: "Joint holder with special wire for automotive applications.",
    partNumber: "SH2200201",
    image: "/products/jointer-holders-relay/jointer-holders/SH2200201.jpg",
    specifications: {
      "Wire Type": "Special",
      "Length": "9 inch",
    },
    tags: ["holder", "jointer", "joint"],
    applications: ["Automotive", "Wire Joining"],
  },
  {
    id: "jh-2",
    name: "Joint Holder with 4mm Deluxe Wire",
    slug: "joint-holder-4mm",
    category: "Holders",
    subcategory: "Jointer Holders",
    description: "Joint holder with 4mm deluxe wire.",
    partNumber: "SH2200211",
    image: "/products/jointer-holders-relay/jointer-holders/SH2200211.jpg",
    specifications: {
      "Wire Type": "4mm Deluxe",
      "Length": "9 inch",
    },
    tags: ["holder", "jointer", "4mm"],
    applications: ["Automotive", "Wire Joining"],
  },
  {
    id: "jh-3",
    name: "H8 & H11 Joint Holder",
    slug: "h8-h11-joint-holder",
    category: "Holders",
    subcategory: "Jointer Holders",
    description: "Joint holder for H8 and H11 bulb connections with 5mm deluxe wire.",
    partNumber: "SH2200551",
    image: "/products/jointer-holders-relay/jointer-holders/SH2200551.jpg",
    specifications: {
      "Wire Type": "5mm Deluxe",
      "Compatible": "H8, H11 Bulbs",
      "Length": "9 inch",
    },
    tags: ["holder", "jointer", "h8", "h11", "bulb"],
    applications: ["Automotive", "Lighting"],
  },
];
